module.exports = __webpack_public_path__ + "img/Academic_Thinking_2.19e5e715.jpg";